import styled from "styled-components";

export const HeroContainer = styled.div`
  width: 100%;
  height: 760px;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  overflow: hidden;
  padding-left: 100px;
  background-image: url("/assets/icons/hero-landingPage.png");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;

  @media screen and (max-width: 1440px) {
    width: 100%;
    height: 700px;
  }

  @media screen and (max-width: 1024px) {
    width: 100%;
    height: 100%;
    padding-left: 40px;
    padding-bottom: 60px;
  }

  @media screen and (max-width: 820px) {
    width: 100%;
    height: 100%;
    padding-left: 40px;
    padding-bottom: 60px;
  }

  @media screen and (max-width: 768px) {
    width: 100%;
    height: 100%;
    padding-left: 40px;
    padding-bottom: 60px;
  }

  @media screen and (max-width: 430px) {
    width: 100%;
    padding-left: 20px;
  }
  @media screen and (max-width: 375px) {
    width: 100%;
    padding-left: 20px;
  }
  @media screen and (max-width: 375px) {
    width: 100%;
    padding-left: 20px;
  }
  @media screen and (max-width: 320px) {
    width: 100%;
    padding-left: 20px;
  }
`;

export const HeroImage = styled.div`
  width: 100%;
  height: 100%;
  background-image: url("/assets/icons/hero-landingPage.png");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  position: relative;

  img {
    width: 100%;
    height: 100%;
    max-width: 100%;
    max-height: 100%;
    object-fit: cover;
  }
`;

export const HeroHolder = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  @media screen and (max-width: 2560px) {
    width: 100%;
    height: 100%;
    justify-content: space-between;
  }
  @media screen and (max-width: 1440px) {
    width: 100%;
    height: 90%;
  }

  @media screen and (max-width: 1024px) {
    width: 100%;
    height: 100%;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: 40px;
  }
  @media screen and (max-width: 768px) {
    width: 100%;
    height: 100%;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 40px;
  }

  @media screen and (max-width: 430px) {
    width: 100%;
    height: 100%;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 30px;
  }
  @media screen and (max-width: 375px) {
    width: 100%;
    height: 100%;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 30px;
  }
`;
